import {
  ImageOff,
  LifeBuoy,
  Link,
  RefreshCw,
  Upload,
  type LucideIcon,
} from 'lucide-react'

export type ErrorAction = 'retry' | 'replace' | 'fix_url' | 'contact_support'

export type ErrorActionHint = {
  action: ErrorAction
  labelKey: string
  icon: LucideIcon
}

const ERROR_ACTION_MAP: Record<string, ErrorActionHint> = {
  INGEST_OCR_VLM_UNAVAILABLE: {
    action: 'retry',
    labelKey: 'sources.status.errorActions.retry',
    icon: RefreshCw,
  },
  INGEST_RETRIES_EXCEEDED: {
    action: 'retry',
    labelKey: 'sources.status.errorActions.retry',
    icon: RefreshCw,
  },
  INGEST_PUBLISH_FAILED: {
    action: 'retry',
    labelKey: 'sources.status.errorActions.retry',
    icon: RefreshCw,
  },
  INGEST_FILE_TOO_LARGE: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.uploadSmallerFile',
    icon: Upload,
  },
  INGEST_UNSUPPORTED_MEDIA_TYPE: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.uploadSupportedFormats',
    icon: Upload,
  },
  INGEST_IMAGE_INVALID_OR_CORRUPT: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.replaceImage',
    icon: ImageOff,
  },
  INGEST_SPREADSHEET_INVALID: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.uploadSupportedFormats',
    icon: Upload,
  },
  INGEST_DOCUMENT_RIGHTS_PROTECTED: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.uploadSupportedFormats',
    icon: Upload,
  },
  INGEST_CAD_PARSE_FAILED: {
    action: 'replace',
    labelKey: 'sources.status.errorActions.reexportAndUpload',
    icon: Upload,
  },
  INGEST_DOWNLOAD_FAILED: {
    action: 'fix_url',
    labelKey: 'sources.status.errorActions.fixUrl',
    icon: Link,
  },
}

const CONTACT_SUPPORT_HINT: ErrorActionHint = {
  action: 'contact_support',
  labelKey: 'sources.status.errorActions.contactSupport',
  icon: LifeBuoy,
}

export function getErrorAction(
  errorCode: string | null | undefined
): ErrorActionHint {
  const trimmedCode = typeof errorCode === 'string' ? errorCode.trim() : ''
  if (trimmedCode.length === 0) {
    return CONTACT_SUPPORT_HINT
  }
  return ERROR_ACTION_MAP[trimmedCode] ?? CONTACT_SUPPORT_HINT
}
